import { APP_CORE_PATHS } from './app';

const { TV, EPG } = APP_CORE_PATHS;

export const TV_PATHS = {
	EPG: `/${TV}/${EPG}`,
	PROGRAM_DETAILS: `/${TV}/kanaly/szczegoly-programu/:id`,
	PLAYER: `/${TV}/kanaly/ogladaj/:id`
};
